import axios from "axios";
import axiosInstance from "../utils/axio-instance";
import { addToast } from './ui.actions';
import i18n from '../i18n';
const MM_URL = process.env.REACT_APP_MM_URL.startsWith('http') ? process.env.REACT_APP_MM_URL : `https://${process.env.REACT_APP_MM_URL}`;

// Links the accepted response to a chat channel. For requests that have their
// own channel (created with the request) the vendor is added to it; requestId
// is optional (the backend can derive it from the response). Returns the
// response body ({ channel: { id } }) or null on failure.
export const createChannel = (userIds, responseId, requestId) => async (dispatch) =>{
   try {
     const response = await axiosInstance.post("/chat/createChannel", { userIds, responseId, requestId });
     dispatch({type:"CREATE_CHANNEL_SUCCESS", payload: response.data});
     return response.data;
   } catch (error) {
     console.error("createChannel failed", error?.message);
     return null;
   }
}

export const removeStepMsg = () => async (dispatch) =>{
  dispatch({type:"REMOVE_STEP_MSG"});
}

export async function getChannels(token){
  try {
    const res = await axios.get(`${MM_URL}/api/v4/users/me/channels`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return res.data;
  } catch (error) {
    console.log('error in getting channnels', error);
    if (error.response && error.response.status === 404) {
      console.log('User not in any team, attempting to add to team...');
      await addUserToTeam();
    }else{
      await addUserToTeam();
      console.log("error", error.response);
    }
    throw error;
  }
}
export const storeChannels = (channels)=> (dispatch) =>{
  dispatch({ type: 'USER_MM_CHANNELS', payload: channels });
}

// GET /api/v4/channels/<channel_id>/posts
export const getDMChannelPosts = async (token, channelId)=>{
  console.log("getDMChannelPosts in action")
  const res = await axios.get(`${MM_URL}/api/v4/channels/${channelId}/posts`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  return res.data;
}

export const addUserToTeam = async ()=>{
   const token = localStorage.getItem("mm_token");
   try{
  // Get user info first
    const userRes = await axios.get(`${MM_URL}/api/v4/users/me`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    console.log("adding usr to team");

    if (userRes.data.id ) {
      // Add user to first available team
      await axios.post(`${MM_URL}/api/v4/teams/${process.env.REACT_APP_MM_TEAM_ID}/members`, {
        user_id: userRes.data.id,
        team_id: process.env.REACT_APP_MM_TEAM_ID
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      const retryRes = await axios.get(`${MM_URL}/api/v4/users/me/channels`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      return retryRes.data;
    }else{
      console.log("no team response");
    }
  }catch(e){
    console.log("error in adding user in team", e.message)
  }
}

export const getChannelPosts = (channelId, posts)=> (dispatch) =>{
  //console.log("getChannelPosts in action")
  dispatch({ type: 'USER_MM_CHANNEL_POSTS', payload: {channelId, posts} });
  //posts.posts is not an arry, it is having objects, key is the post_id
  let userIds = Object.values(posts.posts).map((post) => post.user_id);
  // remove duplicates from userIds
  userIds = [...new Set(userIds)];
  dispatch(getUsers(userIds));
}

export async function getOrCreateDirectChannel(token, userA, userB) {
  const res = await axios.post(
    `${MM_URL}/api/v4/channels/direct`,
    [userA, userB],
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return res.data; // channel object
}

export async function getPosts(channelId) {
 // console.log("getPosts in action");
 const token = localStorage.getItem("mm_token");
  const res = await fetch(`${MM_URL}/api/v4/channels/${channelId}/posts`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  const data = await res.json();
  if(data && data.posts){
    getChannelPosts(channelId, data);
    return Object.values(data.posts).sort((a, b) => a.create_at - b.create_at);
  }
  return [];
}

/**
 * Load a channel's posts into the store, including the authors so names can be
 * rendered.
 *
 * Unlike getPosts above, this actually dispatches -- getPosts calls the
 * getChannelPosts thunk *creator* and throws the returned function away, so
 * nothing ever reaches the store from it.
 */
export const loadChannelPosts = (channelId) => async (dispatch) => {
  const token = localStorage.getItem("mm_token");
  if (!token || !channelId) return null;
  try {
    const res = await axios.get(`${MM_URL}/api/v4/channels/${channelId}/posts`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    if (res.data && res.data.posts) {
      dispatch(getChannelPosts(channelId, res.data));
    }
    return res.data;
  } catch (error) {
    console.log("could not load posts for channel", channelId, error?.message);
    return null;
  }
};

/**
 * The Mattermost base URL with a scheme. REACT_APP_MM_URL is configured as a bare
 * host (message.nexthouse.org) because it is also used to build the wss:// URL,
 * so anything constructing an http URL must go through this.
 */
export const mattermostBaseUrl = MM_URL;

/** Public URL for a Mattermost file attachment. */
export const fileUrl = (fileId) => `${MM_URL}/api/v4/files/${fileId}`;

/** Thumbnail URL for an image attachment; falls back to the full file. */
export const fileThumbnailUrl = (fileId) => `${MM_URL}/api/v4/files/${fileId}/thumbnail`;

/**
 * Newest post in a channel, for the group list preview.
 * Returns null when the channel is empty or unreachable -- a missing preview must
 * never break the list.
 */
export async function getLastPost(channelId) {
  const token = localStorage.getItem("mm_token");
  if (!token || !channelId) return null;
  try {
    const res = await axios.get(`${MM_URL}/api/v4/channels/${channelId}/posts`, {
      params: { per_page: 1 },
      headers: { Authorization: `Bearer ${token}` },
    });
    const { order = [], posts = {} } = res.data || {};
    const newest = order.length ? posts[order[0]] : null;
    return newest || null;
  } catch (error) {
    console.log("could not load last post for channel", channelId, error?.message);
    return null;
  }
}

/**
 * Fetch the newest post for several channels at once and put them in the store,
 * keyed by channel id. Used by the group list.
 */
export const loadLastPosts = (channelIds) => async (dispatch) => {
  const ids = (channelIds || []).filter(Boolean);
  if (!ids.length) return;

  const entries = await Promise.all(
    ids.map(async (channelId) => [channelId, await getLastPost(channelId)])
  );

  const lastPosts = {};
  const authorIds = [];
  entries.forEach(([channelId, post]) => {
    if (!post) return;
    lastPosts[channelId] = post;
    if (post.user_id) authorIds.push(post.user_id);
  });

  dispatch({ type: "USER_MM_LAST_POSTS", payload: lastPosts });
  // So the list can show who sent it.
  if (authorIds.length) dispatch(getUsers([...new Set(authorIds)]));
};

/**
 * Unread message count for one channel, from Mattermost's own read-tracking.
 * This is the same figure Mattermost's own UI uses -- msg_count is already the
 * unread count, not a total that needs subtracting against anything.
 */
export async function getChannelUnread(channelId) {
  const token = localStorage.getItem("mm_token");
  if (!token || !channelId) return null;
  try {
    const res = await axios.get(
      `${MM_URL}/api/v4/users/me/teams/${process.env.REACT_APP_MM_TEAM_ID}/channels/${channelId}/unread`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return res.data; // { msg_count, mention_count, ... }
  } catch (error) {
    console.log("could not load unread count for channel", channelId, error?.message);
    return null;
  }
}

/** Load unread counts for several channels at once, for the group list badges. */
export const loadUnreadCounts = (channelIds) => async (dispatch) => {
  const ids = (channelIds || []).filter(Boolean);
  if (!ids.length) return;

  const entries = await Promise.all(
    ids.map(async (channelId) => [channelId, await getChannelUnread(channelId)])
  );

  const unreadCounts = {};
  entries.forEach(([channelId, unread]) => {
    unreadCounts[channelId] = unread?.msg_count || 0;
  });
  dispatch({ type: "USER_MM_UNREAD_COUNTS", payload: unreadCounts });
};

/**
 * Mark a channel as read, both on the Mattermost server and in the local badge.
 *
 * Best-effort: the local badge always clears even if the server call fails, so a
 * flaky request never leaves a channel stuck looking unread after the user has
 * plainly just opened it.
 */
export const markChannelRead = (channelId) => async (dispatch) => {
  dispatch({ type: "USER_MM_CLEAR_UNREAD", payload: { channelId } });

  const token = localStorage.getItem("mm_token");
  if (!token || !channelId) return;
  try {
    await axios.post(
      `${MM_URL}/api/v4/channels/members/me/view`,
      { channel_id: channelId, prev_channel_id: "" },
      { headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" } }
    );
  } catch (error) {
    console.log("could not mark channel read on the server", channelId, error?.message);
  }
};

/**
 * Which channel the user currently has open, so an incoming websocket message
 * for that channel does not bump its own unread badge while it is on screen.
 * Pass null when no channel is open (e.g. the chat panel unmounts).
 */
export const setActiveChannel = (channelId) => (dispatch) => {
  dispatch({ type: "USER_MM_ACTIVE_CHANNEL", payload: channelId });
};

/** File types the composer accepts. Images and PDF only, for now. */
export const ALLOWED_UPLOAD_TYPES = ["image/png", "image/jpeg", "image/gif", "image/webp", "application/pdf"];
export const MAX_UPLOAD_BYTES = 20 * 1024 * 1024; // 20MB

/**
 * Upload files to a channel and return their Mattermost file ids, which are then
 * attached to a post. Rejects anything that is not an image or a PDF -- the
 * server has its own limits, but failing here gives a usable message.
 */
export async function uploadFiles(channelId, files) {
  const token = localStorage.getItem("mm_token");
  if (!token) throw new Error("Not connected to messaging");
  if (!files || !files.length) return [];

  const fileIds = [];
  for (const file of files) {
    if (!ALLOWED_UPLOAD_TYPES.includes(file.type)) {
      throw new Error(`${file.name} is not an image or PDF`);
    }
    if (file.size > MAX_UPLOAD_BYTES) {
      throw new Error(`${file.name} is larger than 20MB`);
    }

    const form = new FormData();
    form.append("files", file, file.name);
    form.append("channel_id", channelId);

    const res = await axios.post(`${MM_URL}/api/v4/files`, form, {
      headers: { Authorization: `Bearer ${token}` },
    });
    (res.data?.file_infos || []).forEach((info) => fileIds.push(info.id));
  }
  return fileIds;
}

/**
 * Post a message, optionally with uploaded file ids.
 *
 * `options.silent` suppresses the success toast -- a toast per message is fine
 * for the one-off vendor reply but unusable in a real chat window.
 * Resolves to the created post, or null on failure, so callers can clear their
 * input only when the send actually worked.
 */
export const sendPost = (token, channelId, message, fileIds = [], options = {}) => (dispatch) => {
  const payload = { channel_id: channelId, message };
  // Mattermost rejects an empty file_ids array on some versions, so only send it
  // when there is something attached.
  if (fileIds && fileIds.length) payload.file_ids = fileIds;

  return axios.post(`${MM_URL}/api/v4/posts`, payload, {
    headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" }
  }).then((response)=>{
    // Show it straight away rather than waiting on the websocket echo. The
    // reducer dedupes on post.id, so the websocket `posted` event is harmless.
    dispatch(addPostToStore(channelId, response.data));
    if (!options.silent) {
      dispatch(addToast({
            title: i18n.t('team_message_sent_title', 'Message sent successfully'),
            status: 'success',
            duration: 3000,
            isClosable: true,
              position: 'top-right',
          }));
    }
    return response.data;
  }).catch((error)=>{
    console.log(error);
     dispatch(addToast({
          title: i18n.t('team_message_not_sent_title', 'Message not sent'),
          // Server-provided message is left untranslated (data, not UI copy);
          // only the fallback wording is.
          description: error?.response?.data?.message || i18n.t('team_message_not_sent_desc', 'Please sign in again and retry'),
          status: 'error',
          duration: 3000,
          isClosable: true,
            position: 'top-right',
        }));
    return null;
  });
}

export const addPostToStore = (channelId, post)=> (dispatch) =>{
  dispatch({ type: 'USER_MM_NEW_POST', payload: {channelId, post} });
  const userIds = [post.user_id];
  dispatch(getUsers(userIds));
}

export const updateTypingUsr = (userId)=> (dispatch) =>{
  dispatch({ type: 'USER_MM_TYPING', payload: {userId} });
  dispatch(resetTypingUsr());
}
// reset typing user to empty after 10sec of every update
export const resetTypingUsr = ()=> (dispatch) =>{
  setTimeout(() => {
    dispatch({ type: 'USER_MM_TYPING_RESET' });
  }, 10000);
}

export const getUsers = (userIds)=> (dispatch) =>{
  const token = localStorage.getItem("mm_token");
  axios.post(`${MM_URL}/api/v4/users/ids`,userIds, {
    headers: { Authorization: `Bearer ${token}` }
  }).then((response)=>{
    dispatch({ type: 'USER_MM_USERS', payload: response.data });
  }).catch((error)=>{
    console.log("getting users from mm", error);
  });
  return;
}

export const logoutFromMattermost = async () => {
  const token = localStorage.getItem("mm_token");
  if (!token) {
    console.log("No messages token found, skipping logout");
    return;
  }
  
  try {
    const response = await axios.post(`${MM_URL}/api/v4/users/logout`, {}, {
      headers: { Authorization: `Bearer ${token}` },
      withCredentials: true
    });
    
    //console.log("Logout response status:", response.status);
    
    // Check if logout was successful (2xx status codes)
    if (response.status >= 200 && response.status < 300) {
      console.log("Successfully logged out from messages");
      // Remove the token from localStorage to complete the logout
      localStorage.removeItem("mm_token");
    } else {
      console.warn("Unexpected response status from messages logout:", response.status);
      // Still remove token to prevent further API calls
      localStorage.removeItem("mm_token");
    }
  } catch (error) {
    console.error("Error logging out from messages:", error);
    // Even if API call fails, remove the token to prevent further issues
    localStorage.removeItem("mm_token");
  }
};

export const tokenExchange = async ()=>{
  // POST /api/v4/oauth/gitlab/token_exchange {access_token:""}
  const accessToken = localStorage.getItem("token");  
  console.log("token exchange api call", accessToken);
  try {
    const responseJson= await axios.post(`${MM_URL}/api/v4/oauth/keycloak/token_exchange`, {access_token: accessToken}, {
      headers: { "Content-Type": "application/json" }
    });
    //console.log("Successfully logged in to messages", responseJson.data);
    return responseJson.data.token;
  } catch (error) {
    console.error("Error response:", error.response);
    return null;
  }
}
